/// internal client data
import { browser } from '$app/environment';
import { useAccount } from '$lib/account/account';
import type { ClientType } from '$lib/form/form-store';
import { useLocalSession } from '$lib/local-sesson/local-sesson';
import { writable } from 'svelte/store';

// store client data
const client = writable<ClientType | null | undefined>(void 0);

const username = writable<string | undefined>();

export const password_generated = writable<string | undefined>();

export const useClient = () => {
	return {
		client,
		username,
		password_generated
	};
};

// connect datas into local session
const ls = useLocalSession<{
	username: string | undefined;
	password_generated: string | undefined;
}>('chessat3-client');

// set username and password_generated into local session
if (browser) {
	const d = ls.invoke();
	if (d) {
		if (d.username) username.set(d.username);
		if (d.password_generated) password_generated.set(d.password_generated);
	}

	username.subscribe((un) => {
		if (un) ls.set('username', un);
		else ls.delKey('username');
	});

	password_generated.subscribe((pw) => {
		if (pw) ls.set('password_generated', pw);
		else ls.delKey('password_generated');
	});
}

// when account is guest, clear client data
useAccount().account.subscribe((acc) => {
	if (acc === null) {
		client.set(null);
		username.set(void 0);
		password_generated.set(void 0);
	}
});
